"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const constants_1 = require("@powerednow/shared/constants");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
// eslint-disable-next-line no-redeclare
class DocumentContent extends complexData_1.default {
    getCustomerContent() {
        if (this.data.type !== constants_1.DOCUMENT.DOCUMENT_CONTENT_TYPE.CUSTOMER_DATA) {
            return null;
        }
        return this.data.data;
    }
    getCompanyContent() {
        if (this.data.type !== constants_1.DOCUMENT.DOCUMENT_CONTENT_TYPE.COMPANY_DATA) {
            return null;
        }
        return this.data.data;
    }
}
DocumentContent.Entity = entity_1.default;
DocumentContent.modelProperties = modelProperties_1.default;
exports.default = DocumentContent;
//# sourceMappingURL=../../../../src/models/documentContent/index.js.map